module.exports = __webpack_public_path__ + "img/cheeks_and_tzone.ecb7655b.svg";